var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 17.7909 5.79088 16 7.99999 16H12V20C12 22.2091 10.2091 24 7.99999 24C5.79088 24 4 22.2091 4 20Z",
    fill: "#24CB71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V8.00001H16C18.2091 8.00001 20 6.20913 20 4.00001C20 1.79088 18.2091 0 16 0H12Z",
    fill: "#FF7237"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9665 16C18.1757 16 19.9665 14.2091 19.9665 12C19.9665 9.79086 18.1757 8 15.9665 8C13.7574 8 11.9666 9.79086 11.9666 12C11.9666 14.2091 13.7574 16 15.9665 16Z",
    fill: "#00B6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.00001C4 6.20913 5.79088 8.00001 7.99999 8.00001H12V0H7.99999C5.79088 0 4 1.79088 4 4.00001Z",
    fill: "#FF3737"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 14.2091 5.79088 16 7.99999 16H12V8H7.99999C5.79088 8 4 9.79088 4 12Z",
    fill: "#874FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.f6974a4bbf38a891de0e7a17c8ad22f1.svg";
export { ForwardRef as ReactComponent };